import { Popover } from 'foundations-components/transitional/components/Popover';
import EventBoundary from './EventBoundary';

export default EventBoundary(Popover);
